module.exports = __webpack_public_path__ + "static/media/tit_1.f836a0b8.png";